import axios from 'axios'

export default class WebsitesWidgetsServiceClient {
  constructor (practiceUuid) {
    this.client = axios.create({
      baseURL: process.env.VUE_APP_PRACTICE_WIDGETS_SERVICE_DOMAIN,
      headers: {
        'x-api-key': process.env.VUE_APP_PRACTICE_WIDGETS_SERVICE_API_KEY,
        'practice-uuid': practiceUuid
      }
    })
    this.practiceUuid = practiceUuid
  }

  getCustomWidgetSettings (slug) {
    return this.client.get(`/v1/practices/${this.practiceUuid}/custom-widget-settings`, {
      params: {
        slug
      }
    })
  }
}
